module.exports = __webpack_public_path__ + "img/weg.69f67363.svg";